import React from "react";
import css from "./CoachMark.module.scss";
import { coachmark_pin, pointer } from "../../Images/Icons";
import { NavLink } from "react-router-dom";
import { nextStep,backStep } from "../../Var/CoachmarkVar";
import { useDispatch, useSelector } from "react-redux";
const CoachMarkStep1 = () => {

    const dispatch = useDispatch();
    const doNextStep = () => {
        dispatch(
            nextStep(1)
        )
    };
    return (
        <div style={{ position: "relative" }}>
            <div className={css.backdrop}>
                <div className={css.higlight1}>
                    <div className={css.point}>
                        <img src={coachmark_pin}/>
                    </div>
                </div>
                <div className={css.content}>
                    <i class="fi fi-rr-cross-small"></i>
                    <div className={css.title}>👋 Welcome to MODENA Energy Plant Monitoring!</div>
                    <div className={css.desc}>'Choose Plant Management' empowers you to select the plants you wish to monitor. Click here to personalize your dashboard and track your preferred plants' energy usage. Let's tailor your energy monitoring experience for optimal efficiency!</div>
                    <div className={css.step}>1/10</div>
                    
                    <NavLink to="/home" className={css.menu_bar_item} onClick={doNextStep}>
                        <button className={css.next}>Next</button>
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default CoachMarkStep1;
